<template>
    <div class="wrap">
        <TheHeader />
        <main>
            <div class="content inner">
                <div class="list mtb80">
                    <div class="ctrl_bar between">
                        <div class="project_title" v-if="project">
                            <h2>{{ project.projectname }}</h2>
                        </div>
                        <div class="input_box">
                            <select name="project" id="project" @change="changeProject">
                              <option value="">선택</option>
                              <option
                                v-for="p in projectList"
                                :key="p.projectno"
                                :value="p.projectno"
                                :selected="p.projectno === projectno"
                              >
                                {{ p.serial }}
                              </option>
                            </select>
                        </div>
                    </div>
                    <div class="viewer-title">
                      <span class="dot"></span>
                      <span class="text">조감도</span>
                    </div>    
                    <div class="viewer">
                      <template v-if="viewerImages.length">
                        <div class="viewer-grid">
                          <img
                            v-for="(img, index) in viewerImages"
                            :key="index"
                            :src="apiBaseUrl + img"
                            class="viewer-thumb"
                            @click="openViewer(img)"
                          />
                        </div>
                      </template>

                      <template v-else><div class="viewer-empty">
                        <img src="@/assets/imgfile.svg" alt="">
                        <span>등록된 이미지가 아직 없습니다.</span>
                      </div></template>
                    </div>
                    <div class="viewer-title">
                      <span class="dot"></span>
                      <span class="text">음영분석</span>
                    </div>

                    <div class="viewer">
                      <template v-if="shadingImages.length">
                        <div class="viewer-grid">
                          <img
                            v-for="(img, index) in shadingImages"
                            :key="'shading-' + index"
                            :src="apiBaseUrl + img"
                            class="viewer-thumb"
                            @click="openViewer(img)"
                          />
                        </div>
                      </template>

                      <template v-else><div class="viewer-empty">
                        <img src="@/assets/imgfile.svg" alt="">
                        <span>음영분석 이미지가 아직 없습니다.</span>
                      </div></template>
                    </div>
                    <div class="viewer-title">
                      <span class="dot"></span>
                      <span class="text">발전량 분석</span>
                    </div>

                    <div class="viewer">
                      <template v-if="powerImages.length">
                        <div class="viewer-grid">
                          <img
                            v-for="(img, index) in powerImages"
                            :key="'power-' + index"
                            :src="apiBaseUrl + img"
                            class="viewer-thumb"
                            @click="openViewer(img)"
                          />
                        </div>
                      </template>

                      <template v-else><div class="viewer-empty">
                        <img src="@/assets/imgfile.svg" alt="">
                        <span>발전량 분석 이미지가 아직 없습니다.</span>
                      </div></template>
                    </div>
                    <div class="viewer-title">
                      <span class="dot"></span>
                      <span class="text">경제성 분석</span>
                    </div>

                    <div class="viewer">
                      <template v-if="economicImages.length">
                        <div class="viewer-grid">
                          <img
                            v-for="(img, index) in economicImages"
                            :key="'economic-' + index"
                            :src="apiBaseUrl + img"
                            class="viewer-thumb"
                            @click="openViewer(img)"
                          />
                        </div>
                      </template>

                      <template v-else><div class="viewer-empty">
                        <img src="@/assets/imgfile.svg" alt="">
                        <span>경제성 분석 이미지가 아직 없습니다.</span>
                      </div></template>
                    </div>
                    <div class="table">
                        <table>
                            <thead>
                                <tr>
                                    <th>Project No.</th>
                                    <th>평면도(.dwg)</th>
                                    <th>입면도(.dwg)</th>
                                    <th>3D Revit(.rvt)</th>
                                    <th>시뮬레이션 결과(.PDF)</th>
                                    <th>구조 검토(.PDF)</th>
                                    <th>결과 보고서(.PDF)</th>
                                    <!--th>업로드 날짜</th>
                                    <th>비고</th-->
                                </tr>
                            </thead>
                            <tbody v-if="project">
                                <tr>
                                  <td>{{ project.serial }}</td>

                                  <td>
                                    <span class="file" v-if="project.twodcad">
                                      <img src="@/assets/down_ic.svg" @click="download(project.twodcad_path)">
                                      {{ project.twodcad }}
                                    </span>
                                  </td>

                                  <td>
                                    <span class="file" v-if="project.twodcad2">
                                      <img src="@/assets/down_ic.svg" @click="download(project.twodcad2_path)">
                                      {{ project.twodcad2 }}
                                    </span>
                                  </td>

                                  <td>
                                    <span class="file" v-if="project.threedrevit">
                                      <img src="@/assets/down_ic.svg" @click="download(project.threedrevit_path)">
                                      {{ project.threedrevit }}
                                    </span>
                                  </td>

                                  <td>
                                    <span class="file" v-if="project.simulation_result">
                                      <img src="@/assets/down_ic.svg" @click="download(project.simulation_result_path)">
                                      {{ project.simulation_result }}
                                    </span>
                                  </td>

                                  <td>
                                    <span class="file" v-if="project.structure">
                                      <img src="@/assets/down_ic.svg" @click="download(project.structure_path)">
                                      {{ project.structure }}
                                    </span>
                                  </td>

                                  <td>
                                    <span class="file" v-if="project.result">
                                      <img src="@/assets/down_ic.svg" @click="download(project.result_path)">
                                      {{ project.result }}
                                    </span>
                                  </td>

                                  <!--td>{{ project.created_at?.substring(0,10) }}</td>
                                  <td>{{ project.addition || '-' }}</td-->
                                </tr>
                                </tbody>
                        </table>
                    </div>
           
                    <div class="comment">
                      <h2>Comments</h2>

                      <div class="comm_inp">
                        <img src="@/assets/name_img.png" alt="">
                        <div class="input_area">
                          <input
                            type="text"
                            v-model="commentText"
                            placeholder="Add a comment"
                          >
                          <button type="button" @click="submitComment">등록</button>
                        </div>
                      </div>

                      <!--div
                        class="comm_text"
                        v-for="c in comments"
                        :key="c.id"
                      >
                        <div class="name">
                          <img src="@/assets/name_img.png" alt="">
                          <p>{{ c.username }}</p>
                        </div>
                        <div class="text">
                          <p>{{ c.comment }}</p>
                          <span class="date">
                            {{ c.timecreated?.substring(0,16) }}
                          </span>
                        </div>
                      </div-->

                      <div class="comm_wrap">
                        <div
                          class="comm_box"
                          :class="c.userid == loginUserId ? 'right' : 'left'"
                          v-for="c in comments"
                          :key="c.id"
                        >
                          <div class="box">
                            <div class="name">
                              <img src="@/assets/name_img.png" alt="">
                              <div class="name_text">
                                <p>{{ c.username }}</p>
                                <span>{{ c.timecreated?.substring(0,16) }}</span> 
                              </div>
                            </div>

                            <div class="balloon">
                              <p>{{ c.comment }}</p>
                            </div>
                          </div>
                        </div>    
                      </div>
                    </div>
                </div>
            </div>
        </main>
        <!--div class="floating">
            <a href="">
                <span class="material-symbols-sharp">add</span>
                BIM 설계 및 시뮬레이션 의뢰
            </a>
        </div-->
        <!-- 3D Viewer Popup -->
        <div v-if="showViewerPopup" class="viewer-popup">
          <div class="overlay" @click="closeViewer"></div>

          <div class="popup-content">
            <button class="close-btn" @click="closeViewer">×</button>

            <img
              :src="apiBaseUrl + popupImage"
              alt="3D Viewer Large"
            />
          </div>
        </div>
        <TheFooter />
    </div>
</template>

<script>
import TheHeader from '@/components/TheHeader.vue'
import TheFooter from '@/components/TheFooter.vue'
import api from '@/api'

export default {
  name: 'DesignSimulationView',
  components: { TheHeader, TheFooter },

  data() {
    return {
      projectno: '',
      projectname: '',
      projectList: [],
      project: null,
      apiBaseUrl: api.defaults.baseURL,
      commentText: '', 
      comments: [],
      loginUserId: null,
      showViewerPopup: false,
      popupImage: ''
    }
  },

  async mounted() {
    const params = new URLSearchParams(window.location.search);
    this.projectno = params.get('projectno');

    if (!this.projectno) return;

    await this.fetchProject();
  },

  computed: {
  viewerImages() {
    if (!this.project) return [];

    const images = [];

    if (this.project.threedviewer_path) {
      images.push(this.project.threedviewer_path);
    }
    if (this.project.twodcad_img) {
      images.push(this.project.twodcad_img);
    }
    if (this.project.twodcad2_img) {
      images.push(this.project.twodcad2_img);
    }

    return images;
  },

  shadingImages() {
    if (!this.project) return [];
    return [
      this.project.shading_analysis_img1,
      this.project.shading_analysis_img2,
      this.project.shading_analysis_img3
    ].filter(Boolean);
  },

  powerImages() {
    if (!this.project) return [];
    return [
      this.project.power_generation_img1,
      this.project.power_generation_img2,
      this.project.power_generation_img3
    ].filter(Boolean);
  },

  economicImages() {
    if (!this.project) return [];
    return [
      this.project.economic_analysis_img,
      this.project.economic_analysis_img2,
      this.project.economic_analysis_img3    
    ].filter(Boolean);
  }
},

  methods: {
    openViewer(path) {
      this.popupImage = path;
      this.showViewerPopup = true;
    },

    closeViewer() {
      this.showViewerPopup = false;
      this.popupImage = '';
    },
        async submitComment() {
              if (!this.commentText.trim()) {
                alert('댓글을 입력하세요.');
                return;
              }

              try {
                await api.post(
                  '/admin/api_project_comment_store',
                  {
                    projectno: this.projectno,
                    comment: this.commentText
                  },
                  { withCredentials: true }
                );

                this.commentText = '';
                await this.fetchComments(); // 👈 즉시 리프래시
              } catch (e) {
                console.error(e);
                alert('댓글 등록 실패');
              }
      },
      async fetchComments() {
          try {
            const res = await api.get('/admin/api_project_comments', {
              params: { projectno: this.projectno },
              withCredentials: true
            });

            this.comments = res.data.comments;
            this.loginUserId = res.data.login_userid;
            console.log('comments:', this.comments);
          } catch (e) {
            console.error(e);
          }
    },
    async fetchProject() {
      try {
        const res = await api.get('/admin/api_project_view', {
          params: { projectno: this.projectno },
          withCredentials: true
        });

        this.projectList = res.data.projects;
        this.project = res.data.project;

        await this.fetchComments();
      } catch (e) {
        console.error(e);
      }
    },

    changeProject(e) {
      const value = e.target.value;
      if (!value) return;

      window.location.href = `/design_simulation_view?projectno=${value}`;
    },

    download(path) {
      if (!path) return;
      window.location.href = api.defaults.baseURL + '/' + path;
    }
  }
}
</script>
<style scoped>
.ctrl_bar.between {
    display: flex;
    justify-content: space-between; /* 양 끝 정렬 */
    align-items: center;            /* 세로 중앙 정렬 */
    margin-bottom: 20px;
    border-bottom: 2px solid #f1f1f1; /* 구분선 (선택사항) */
    padding-bottom: 15px;
}

.project_title h2 {
    font-size: 24px;
    font-weight: 700;
    color: #111;
    margin: 0;
    position: relative;
    padding-left: 15px;
}

/* 타이틀 왼쪽에 포인트 포인트 선 추가 (선택사항) */
.project_title h2::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 20px;
    background-color: #d73139; /* 포인트 컬러 */
    border-radius: 2px;
}    
.viewer-grid {
  display: flex;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
}

.viewer-thumb {
  width: 100%;
  height: 180px;
  object-fit: cover;
  cursor: pointer;
  border-radius: 8px;
  border: 1px solid #ddd;
  transition: transform 0.2s ease;
}

.viewer-thumb:hover {
  transform: scale(1.03);
}
.viewer-empty {
  display: flex;
  flex-direction: column;   /* 👈 세로 */
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 40px 0;
  color: #999;
  font-size: 14px;
}

.viewer-empty img {
  width: 48px;
  opacity: 0.6;
}
.viewer-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 24px 0 12px;
  text-align: left;
}

.viewer-title .dot {
  width: 6px;
  height: 6px;
  background-color: #111;
  border-radius: 50%;
  flex-shrink: 0;
}

.viewer-title .text {
  font-size: 16px;
  font-weight: 600;
  color: #111;
}
</style>